var _style, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 891.8 651.4",
    style: {
      enableBackground: "new 0 0 891.8 651.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#179B48;}\r\n\t.st1{fill:#08783D;}\r\n\t.st2{fill:#070506;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,0h585.3c34.1,0,61.8,27.7,61.8,61.8v527.8c0,34.1-27.7,61.8-61.8,61.8H61.8C27.7,651.4,0,623.8,0,589.6 V61.8C0,27.7,27.7,0,61.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M514.5,486.7h355.4c12.1,0,21.9,9.8,21.9,21.9v56.9c0,12.1-9.8,21.9-21.9,21.9H514.5 c-12.1,0-21.9-9.8-21.9-21.9v-56.9C492.7,496.5,502.5,486.7,514.5,486.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,0h578.1c37.9,0,68.6,30.7,68.6,68.6l0,0v5.3l0,0H1.4l0,0V62.2C1.4,27.9,29.2,0,63.6,0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 53.3,
    cy: 37,
    r: 12.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 99.8,
    cy: 37,
    r: 12.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 145.9,
    cy: 37,
    r: 12.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.4,306.5c2.3-7.2,7-12.5,12.4-17.5c43.9-41.5,95.5-68.6,154.9-79.1c90.3-16,172.6,3.8,245.7,59.7 c9.6,7.3,18.4,15.6,27.3,23.9c8,7.5,10,18.3,5.7,27.6c-4.1,9-13.2,14.6-23.1,14.2c-6.7-0.4-11.9-3.8-17-8.1 C513,316.8,501,306,487.9,296.9c-31.5-22-66.7-35.5-104.7-41.1c-60.1-9-116.8,1.4-169.6,31.6c-18.6,10.8-35.7,23.8-51.1,38.7 c-3,3-6.4,5.5-10.2,7.3c-12.5,5.4-26.6-1-31.5-13.7c-0.4-1.2-1-2.3-1.5-3.5L119.4,306.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.6,297.4c65,1.1,115,21.2,156.7,61.6c13,12.6,10.3,32.3-5.4,39.8c-8.6,4.1-17.1,3.4-24.7-2.6 c-6.1-4.8-11.5-10.3-17.6-15.1c-20.4-16.2-44.4-27.2-69.9-32.1c-48.2-9.5-98.1,2.7-136.3,33.5c-5.1,4.1-9.7,8.9-14.8,13 c-14.8,11.9-35.7,4.2-39-14.5c-1.5-8.6,1.5-15.8,7.6-21.8c29.9-29.3,65.2-48.7,106.2-56.9C313.9,299.4,328.8,298.4,336.6,297.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.2,389.3c35.4,0.4,63.9,12.1,87.7,35.1c9.8,9.4,10.3,23.9,1.4,33.8c-8.6,9.7-23.4,10.6-33.1,2 c-0.1-0.1-0.1-0.1-0.2-0.2c-10.9-9.8-22.7-17.7-37.3-20.7c-23.9-4.9-45.3,0.2-64.2,15.7c-2.9,2.4-5.6,5.2-8.8,7.2 c-11.3,6.9-26.1,3.4-33-7.9c-5.8-9.5-4.4-21.7,3.5-29.6c19.4-19,42.6-30.7,69.6-34.2C332.4,389.9,337.9,389.6,341.2,389.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.6,543.3c-17.2,0.3-32-14.2-32.3-31.8c-0.3-17.2,14.3-31.9,31.9-32.2c17.2-0.3,31.9,14.2,32.3,31.8 C375.8,528.2,361.2,543,343.6,543.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.7,429.5c-2.9,10.2-13.2,16.9-24.1,16.1c-9.7-0.7-18-7.4-20.4-16.5c-6.2-78.6-12.3-157.1-18.5-235.7 c-4.3-30.2,19.7-54.6,43.2-54.3c23.2,0.3,46.3,24.6,42,54.3C384.5,272.1,377.1,350.8,369.7,429.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.e2c5aacc057a17993fe2fc4b54434587.svg";
export { ForwardRef as ReactComponent };